import {
  AppBar,
  Box,
  Button,
  CardMedia,
  Container,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ReactComponent as CloseIcon } from "assets/Icons/close.svg";
import { ReactComponent as MenuIcon } from "assets/Icons/Menu.svg";
import xane from "assets/logo/xaneLogo.png";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleLogoClick = () => {
    navigate("/");
  };
  const handleAbout = () => {
    navigate("/about");
    setIsMenuOpen(false);
  };
  const handleWorks = () => {
    navigate("/works");
    setIsMenuOpen(false);
  };
  const handleBlogs = () => {
    navigate("/blogs");
    setIsMenuOpen(false);
  };
  const handleBookDemo = () => {
    navigate("/contact");
    setIsMenuOpen(false);
  };
  // Set background color conditionally
  const isAboutPage = location.pathname === "/about" || location.pathname.startsWith("/blog/");
  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: theme.zIndex.appBar,
        top: 10,
        width: "100%",
        maxWidth: {
          xs: "90%",
          sm: theme.breakpoints.values.sm,
          md: theme.breakpoints.values.md,
          lg: theme.breakpoints.values.lg,
        },
        margin: "0 auto",
        display: "flex",
        padding: {
          xs: "10px 20px 10px 10px",
          sm: "10px 30px 10px 10px",
          md: "10px 10px 10px 24px",
        },
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "stretch",
        gap: "24px",
        borderRadius: "40px",
        border: "1px solid #999",
        background: isAboutPage ? "#fff" : "rgba(255, 255, 255, 0.5)",
        backdropFilter: "blur(4px)",
        height: { xs: "44px", sm: "64px", md: "84px" },
      }}
    >
      <Toolbar
        sx={{
          position: "absolute",
          width: "100%",
          left: 0,
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "stretch",
          gap: "24px",
        }}
      >
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            width: "inherit",
            cursor: "pointer",
            border: "1px solid red",
            height: "48px",
            alignItems: "flex-start",
          }}
          onClick={handleLogoClick}
        >
          <CardMedia
            component="img"
            src={xane}
            alt="Logo"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "scale-down",
            }}
          />
        </Box> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            width: "inherit",
            cursor: "pointer",
            height: { xs: "32px", sm: "48px", md: "48px" },
            alignItems: "flex-start",
            overflow: "hidden",
          }}
          onClick={handleLogoClick}
        >
          <CardMedia
            component="img"
            src={xane}
            alt="Logo"
            sx={{
              height: "100%",
              width: "auto",
              maxWidth: "none",
              objectFit: "contain",
            }}
          />
        </Box>
        {isMobile ? (
          <IconButton aria-label="open menu" onClick={handleMenuClick}>
            <MenuIcon />
          </IconButton>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 3,
                width: "inherit",
              }}
            >
              <Button
                variant="text"
                sx={{
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "19px",
                  lineHeight: 1.4,
                  color: "#666666",
                }}
                onClick={handleAbout}
              >
                About Us
              </Button>
              <Button
                variant="text"
                sx={{
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "19px",
                  lineHeight: 1.4,
                  color: "#666666",
                }}
                onClick={handleWorks}
              >
                How It Works
              </Button>
              <Button
                variant="text"
                sx={{
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "19px",
                  lineHeight: 1.4,
                  color: "#666666",
                }}
                onClick={handleBlogs}
              >
                Blogs
              </Button>
            </Box>
            <Box
              sx={{
                width: "inherit",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  display: "flex",
                  padding: "10px 24px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "64px",
                  borderRadius: "30px",
                  border: "2px solid #FFF",
                  background: "linear-gradient(180deg, #0E0E0E 0%, #333 100%)",
                  boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
                  textTransform: "none",
                }}
                onClick={handleBookDemo}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "19px",
                    lineHeight: 1.4,
                  }}
                >
                  Book A Demo
                </Typography>
              </Button>
            </Box>
          </>
        )}
      </Toolbar>
      {isMenuOpen && isMobile && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: { xs: "550px", sm: "auto" },
            display: "flex",
            flexDirection: "column",
            border: "0.5px solid #999",
            borderRadius: { xs: "20px", sm: "30px" },
            boxShadow: "0px 8px 24px 0px rgba(78, 100, 122, 0.15)",
            padding: { xs: "4px 10px 24px 10px", sm: "12px 20px 24px 20px" },
            alignItems: "flex-end",
            gap: { xs: "48px", sm: "24px" },
            background: "#FCFCFC",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: { xs: "12px", sm: "0px" },
              alignItems: "center",
              alignSelf: "stretch",
              gap: { xs: "48px", sm: "10px" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                padding: { xs: "0px 0px 8px 0px", sm: "0px 12.8px 0px 3px" },
                alignItems: "flex-end",
                flex: "1 0 0",
                justifyContent: "flex-start",
                width: "inherit",
                cursor: "pointer",
                height: "48px",
                overflow: "hidden", // Prevents spill-out
              }}
            >
              <CardMedia
                component="img"
                src={xane}
                alt="Logo"
                sx={{
                  height: "100%",
                  width: "auto",
                  maxWidth: "none",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                padding: { xs: "10px" },
                alignItems: { xs: "center" },
                gap: { xs: "10px" },
              }}
            >
              <IconButton onClick={handleMenuClick}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "36px",
              flex: "1 0 0",
              alignSelf: "stretch",
            }}
          >
            <Button
              variant="text"
              sx={{
                textTransform: "capitalize",
                fontWeight: 600,
                fontSize: { xs: "16px", sm: "19px" },
                lineHeight: 1.4,
              }}
              onClick={handleAbout}
            >
              About Us
            </Button>
            <Button
              variant="text"
              sx={{
                textTransform: "capitalize",
                fontWeight: 600,
                fontSize: { xs: "16px", sm: "19px" },
                lineHeight: 1.4,
              }}
              onClick={handleWorks}
            >
              How It Works
            </Button>
            <Button
              variant="text"
              sx={{
                textTransform: "capitalize",
                fontWeight: 600,
                fontSize: { xs: "16px", sm: "19px" },
                lineHeight: 1.4,
              }}
              onClick={handleBlogs}
            >
              Blogs
            </Button>
          </Box>

          <Button
            variant="contained"
            sx={{
              display: "flex",
              height: { xs: "56px", sm: "64px" },
              padding: "10px 24px",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              alignSelf: "stretch",
              borderRadius: "30px",
              border: "2px solid #FFF",
              textTransform: "none",
              background: "linear-gradient(180deg, #0E0E0E 0%, #333 100%)",
            }}
            onClick={handleBookDemo}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "16px", sm: "19px" },
                lineHeight: 1.4,
                color: "#FFF",
              }}
            >
              Book a Demo
            </Typography>
          </Button>
        </Box>
      )}
    </AppBar>
  );
}
